// Move the interfaces and default values here from FiltersSidebar.tsx

export interface ImageFilter {
  checked: boolean;
  imageCount: number;
  operator: string;
}

export interface AssetFilters {
  asset_id?: string;
  start_date?: string;
  end_date?: string;
  croppedImages: ImageFilter;
  configuration?: string;
  bgrImages: ImageFilter;
  exteriorImages: ImageFilter;
  featuredImages: ImageFilter;
  manualImages: ImageFilter;
  panoramicImages: ImageFilter;
  ucImages: ImageFilter;
  pushed?: boolean | null;
  syndicated?: boolean | null;
  processingStatus: string;
  syndicationStatus: string;
  archived: boolean;
}

export const defaultImageFilterValue: ImageFilter = {
  checked: false,
  imageCount: 0,
  operator: '=',
};

export const defaultFilters: AssetFilters = {
  asset_id: undefined,
  start_date: undefined,
  end_date: undefined,
  croppedImages: defaultImageFilterValue,
  configuration: undefined,
  bgrImages: defaultImageFilterValue,
  exteriorImages: defaultImageFilterValue,
  featuredImages: defaultImageFilterValue,
  manualImages: defaultImageFilterValue,
  panoramicImages: defaultImageFilterValue,
  ucImages: defaultImageFilterValue,
  pushed: null,
  syndicated: null,
  processingStatus: "any",
  syndicationStatus: "any",
  archived: false,
};